export default {"src":"/_next/static/media/step3.92e9a854.svg","height":44,"width":64};